import * as React from 'react';

import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

type Props = { count: number; index: number };

const Track = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Indicator = styled.div`
  height: 0.2rem;
  background-color: ${theme.color.common.gray50};
  position: relative;
  border-radius: 1rem;
  transition: left 250ms;
`;

export const ProgressBar = ({ count, index }: Props) => {
  if (count < 2) {
    return null;
  }

  const width = 100 / count;
  const left = width * index;

  return (
    <Track data-testid="progress-bar">
      <Indicator style={{ width: `${width}%`, left: `${left}%` }} />
    </Track>
  );
};
